import { Injectable } from '@angular/core';
import { SicorApiService } from '../SicorService/sicor-api.service';
import { take, tap } from 'rxjs/operators';
import { CyberSafeguardSignal } from '../SicorService/RequestObject/CyberSafeguardSignal';
import { ModalController } from '@ionic/angular';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { GlobalMethodsService } from '../global-methods.service';
import { NavigationService } from './navigation.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CyberSafeguardService {
  constructor(private sicorAPI: SicorApiService,
    private navigation: NavigationService,
    private translate: TranslateConfigService,
    private modalCtrl: ModalController,
    public gms: GlobalMethodsService) { }

  public async sendCyberSafeguardSignal(requestParams: CyberSafeguardSignal, originScreen): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.sendCyberSafeguardSignal(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null && res.resultSet[0] != null && res.resultSet[0].error != null) {
              if (res.resultSet[0].error === 401) {
                this.modalCtrl.dismiss(false, '', 'loadSpinner');
                if (originScreen === 'countdown') {
                  this.modalCtrl.dismiss(false, '', 'countDownModal');
                }
                resolve(undefined);
                await this.navigation.logout();
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
              } else {
                resolve(true);
              }
            } else {
              resolve(false);
            }
          },
          error: e => {
            resolve(null);
          }
        })
      ));
    });
  }
}
